import { render } from "./StripeView.vue?vue&type=template&id=187c37c6&scoped=true"
import script from "./StripeView.vue?vue&type=script&lang=js"
export * from "./StripeView.vue?vue&type=script&lang=js"

import "./StripeView.vue?vue&type=style&index=0&id=187c37c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187c37c6"]])

export default __exports__